var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input",staticClass:"input-text",attrs:{"spellcheck":"false","autocomplete":"off"}},'input',_vm.inputAttributes,false),_vm.inputListeners))}
var staticRenderFns = []

export { render, staticRenderFns }